import { ExternalLink } from "@octopusdeploy/design-system-components";
import { OverviewContainer, OverviewHighlightText, LearnMoreResources, TopicsContainer } from "./CommonViews";
export const CommonConfigurationJiraServiceManagementIntegrationOverview = () => {
    return (<OverviewContainer>
            <OverviewHighlightText>
                <p>
                    The <ExternalLink href="https://oc.to/JiraServiceManagementIntegration">Jira Service Management integration</ExternalLink> blocks deployments or runbooks until there's an approved change request. It links to existing requests or
                    automatically creates new ones, so you stay compliant without the manual work.
                </p>
            </OverviewHighlightText>
        </OverviewContainer>);
};
export const CommonConfigurationJiraServiceManagementIntegrationTopics = () => {
    return (<TopicsContainer>
            <LearnMoreResources>
                <div>
                    <ExternalLink href="https://oc.to/approvals">Approvals</ExternalLink>
                </div>
            </LearnMoreResources>
        </TopicsContainer>);
};
